type Protocol = `${string}:`;

function sanitizeUrl(value: string, allowedProtocols: Protocol[]) {
  const anchor = document.createElement('a');
  anchor.href = value;

  if (
    value.trim() !== '' &&
    allowedProtocols.includes(anchor.protocol as Protocol)
  ) {
    if (!value.startsWith(anchor.protocol) && !value.startsWith('#')) {
      return `https://${value}`;
    }

    return value;
  }

  return null;
}

export const sanitizeAnnotationLink = (value: string) =>
  sanitizeUrl(value, ['https:', 'http:']);

export const sanitizeActionLink = (value: string) =>
  sanitizeUrl(value, ['https:', 'http:']);

export const sanitzieQuillLink = (value: string) =>
  sanitizeUrl(value, ['https:', 'http:', 'mailto:', 'tel:', 'webcal:']);
